import api from './api';
import Axios from 'axios';
import { getJwt } from '@app/helpers';
import { trackPromise } from 'react-promise-tracker';
import { compareText } from '@app/helpers/comparators';

export interface Usuario {
    id: string;
    email?: string;
    foto?: string;
    identificadorErp?: string;
    nome?: string;
    telefone1?: string;
    telefone2?: string;
    username?: string;
    tipoUsuario?: string;
    tipoUsuarioCodigo?: number;
    status: string;
    cargo?: string;
    perfis?: string[];
    contrato?: string;
    fornecedor?: string;
    dataHoraUltimaAcesso?: Date;

    departamentoNome: string;
    areaNome: string;
    diretoriaNome: string;
}

export interface UsuarioTableProps extends Usuario {
    numeroLinha: number
}

export interface UsuarioUltimaAcesso {
    usuarioId: string;
    nome: string;
    userName: string;
    email: string;
    ultimoAcesso: string;
    quantidadeDiasSeAcessoAoSistema: string;
    statusUsuario: string;
}

export interface HistoricoUsuarioLogin {
    entrada: boolean;
    dataHoLogin: string;
    numeroLinha: number;
}


export interface UsuarioUltimaAcessoFiltro {
    dataInicio: Date;
    dataFinal: Date;
}

export const getAllUsuarios = () => api.get<Usuario[]>('usuarios');
export const getAllUsuariosAtivos = () => api.get<Usuario[]>(`usuarios/ativos`);
export const getAllUsuariosPorPerfil = (codigoPerfil: number) => api.get<Usuario[]>(`usuarios/perfil/${codigoPerfil}`);
export const getAllUsuariosMRN = () => api.get<Usuario[]>('usuarios/mrn');
export const getUsuarioInfo = (id: any) => api.get<Usuario>(`usuarios/${id}`);
export const getUsuarioPermissions = (id: any) => api.get<string[]>(`usuarios/getPermissions/${id}`);
export const updateUsuario = (usuario: Usuario) => { return api.put(`usuarios/${usuario.id}`, usuario); }
export const getAllOptions = () =>
    getAllUsuarios().then(usuarios => (usuarios || []).map(a => ({ text: a.nome, value: a.id && a.id.toString() })));

export const getAllUsuariosMRNOptions = () =>
    getAllUsuariosMRN().then(usuarios => (usuarios || []).map(a => ({ text: a.nome, value: a.id && a.id.toString() })));

export const getAllUsuariosAtivosOptions = () =>
    getAllUsuariosAtivos().then(usuarios => (usuarios || []).map(a => ({ text: a.nome, value: a.id && a.id.toString() })));

export const getAllUsuariosAtivosNomeOptions = () =>
    getAllUsuariosAtivos().then(usuarios => (usuarios || []).toSorted((a, b) => compareText(a.nome, b.nome)).map(a => ({ text: a.nome, value: a.nome })));

export const ativarUsuario = (usuarioId: Usuario) => api.put(`usuarios/ativarUsuario/${usuarioId}`);
export const inativarUsuario = (usuarioId: Usuario) => api.put(`usuarios/inativarUsuario/${usuarioId}`);
export const changePassword = (usuarioId: string, data: any) => api.put(`usuarios/changePassword/${usuarioId}`, data);
export const updatePrimeiroAcesso = (data: any) => api.put(`usuarios/updateFirstAccess/`, data);
export const getAllUsuariosMRNAndTerceiro = () => api.get<Usuario[]>('usuarios/mrnandterceiro');
export const getAllUsuariosMRNAndTerceiroOptions = () =>
    getAllUsuariosMRNAndTerceiro().then(usuarios =>
        (usuarios || []).map(a => ({ text: a.nome, value: a.id && a.id.toString() })),
    );


export const registarLogout = (usuarioId: string) => {
    api.get(`account/registarLogout/${usuarioId}`);
}

export const getAllUsuarioUltimaAcessoFiltro = (filtro: UsuarioUltimaAcessoFiltro) => {
    return api.post<UsuarioUltimaAcesso[]>('usuarios/getAllUsuarioUltimaAcessoFiltro/', filtro, { disableNotification: 'true' });
}

export const getAllHistoricoUsuarioLogin = (usuarioId: string) => {
    return api.get<HistoricoUsuarioLogin[]>(`account/getAllHistoricoUsuarioLogin/${usuarioId}`);
}


export const exportarUsuarioUltimaAcessoFiltro = (filtro: UsuarioUltimaAcessoFiltro) => {

    let urlBase = window.location.origin;
    trackPromise(Axios.post(urlBase + `/api/usuarios/exportarUsuarioUltimaAcessoFiltro`, filtro,
        {
            responseType: 'blob',
            headers: {
                Authorization: `Bearer ${getJwt()}`,
            },
        }).then(resp => {
            const url = window.URL.createObjectURL(new Blob([resp.data]));
            const link = document.createElement('a');
            link.href = url;
            link.setAttribute('download', "relatorioUsuarioUltimoAcesso.xlsx");
            link.setAttribute('id', 'relatorioUsuarioUltimoAcesso');
            document.body.appendChild(link);
            link.click();
            document.getElementById('relatorioUsuarioUltimoAcesso').outerHTML = '';
        }));
};
